import { render, staticRenderFns } from "./MainProjectSchematicView.vue?vue&type=template&id=7f9e5e7f&scoped=true&"
import script from "./MainProjectSchematicView.vue?vue&type=script&lang=ts&"
export * from "./MainProjectSchematicView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9e5e7f",
  null
  
)

export default component.exports